import { customTheme } from '@/assets/scss/theme/Theme';
import { ThemeProvider } from '@emotion/react';
import { StyledEngineProvider, unstable_createMuiStrictModeTheme } from '@mui/material';
import { ODSSpinner } from 'kfone-component-library';
import 'kfone-component-library/font-faces.css';
import 'kfone-component-library/style.css';
import type { SpinnerProps } from 'kfone-component-library/types';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './app/store';
import './i18n';
import './index.scss';

const spinnerBackdrop: SpinnerProps = {
  id: 'spinner-backdrop-kfone-kfnr',
  hasBackdrop: true,
};

const theme = unstable_createMuiStrictModeTheme(customTheme);
/* disable console on prod */
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
}

//Detect the users browser language automatically
//const userLanguage = localization_detectBrowserLanguages();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <React.Suspense fallback={<ODSSpinner {...spinnerBackdrop} />}>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <Provider store={store}>
              <SnackbarProvider
                maxSnack={3}
                preventDuplicate
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              >
                <App />
              </SnackbarProvider>
            </Provider>
          </BrowserRouter>
        </React.Suspense>
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
